<app-stages [stages]="stages" currentStage="Projekt organizacji ruchu">
</app-stages>
<br>
@if (!pending() && !loading()) {
  <form autocomplete="off" novalidate [formGroup]="form" (ngSubmit)="submitAndGoNext()">
    <div class="row">
      <div class="col-md-3">
        <div class='form-group' *ngIf='"projectType" as controlName'>
          <label [for]='controlName'>
            Typ projektu *
          </label>
          <select
            (change)="form.projectTypeChange(form.getElement($event).value)"
            [id]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            [formControlName]='controlName'>
            <option value=''>Wybierz</option>
            <option [value]='item' *ngFor='let item of form.projectTypes'>
              {{ item }}
            </option>
          </select>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
      <div class="col-md-4">
        <div class='form-group' *ngIf='"roadCategory" as controlName'>
          <label [for]='controlName'>
            Kategoria drogi *
          </label>
          <select
            [id]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            [formControlName]='controlName'>
            <option value=''>Wybierz</option>
            <option value='Gminna'>Gminna</option>
            <option value="Powiatowa">Powiatowa</option>
          </select>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
      <div class='col-md-5'>
        <div class='form-group' *ngIf='"projectTitle" as controlName'>
          <label [for]='controlName'>
            Tytuł projektu *
          </label>
          <input
            [id]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            [formControlName]='controlName'
            placeholder='Wpisz tu tytuł projektu'
            type='text'>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
      <div class="col-12">
        <div class='form-group' *ngIf='"trafficOrganizationDescription" as controlName'>
          <label [for]='controlName'>
            Opis projektu organizacji ruchu *
          </label>
          <textarea
            rows="4"
            [id]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            [formControlName]='controlName'
            placeholder='Wpisz tu opis'>
            </textarea>
          <app-validation-errors [showTextLength]="true" [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
    </div>
    <div class="row">
      <div class='col-md-6'>
        <div class='form-group' *ngIf='"investor" as controlName'>
          <label [for]='controlName'>
            Inwestor / Zarządca drogi *
          </label>
          <input
            [id]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            [formControlName]='controlName'
            placeholder='Wpisz tu Inwestora/Zarządcę drogi'
            type='text'>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
    </div>

    <div class='row'>
      <div class="col-12">
        <div class="form-group mb-0 mt-3">
          @for (item of form.localisationDataTypes; track $index) {
            <div class="custom-radio custom-inline">
              <input (change)="form.localisationDataTypeChange(item)"
                     name="localisationDataType"
                     formControlName="localisationDataType"
                     type="radio"
                     [value]="item"
                     [id]="'localisationDataType' + $index">
              <label [for]="'localisationDataType' + $index">
                {{ item }}
              </label>
            </div>
          }
        </div>
      </div>
      <div class='col-md-4'>
        <div class='form-group' *ngIf='"city" as controlName'>
          <label [for]='controlName'>
            Miejscowość *
          </label>
          <select
            [id]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            [formControlName]='controlName'>
            <option value=''>Wybierz</option>
            @for (item of form.getTownList(form.localisationDataType.value); track $index) {
              <option [value]='item'>{{ item }}</option>
            }
          </select>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
      @if (form.roadNumber) {
        <div class='col-md-3'>
          <div class='form-group' *ngIf='"roadNumber" as controlName'>
            <label [for]='controlName'>
              Numer drogi *
            </label>
            <select
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              (change)="form.roadNumberChange(form.getElement($event).value)"
              [formControlName]='controlName'>
              <option value=''>Wybierz</option>
              @for (item of form.getRoadList(form.city.value); track $index) {
                <option [value]='item.roadNumber'>{{ item.roadNumber }}</option>
              }
            </select>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      }
      @if (form.roadName) {
        <div class='col-md-5'>
          <div class='form-group' *ngIf='"roadName" as controlName'>
            <label [for]='controlName'>
              Nazwa drogi *
            </label>
            <input
              readonly
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              placeholder='Wpisz tu nazwę drogi'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      }
      @if (form.street) {
        <div class='col-md-3'>
          <div class='form-group' *ngIf='"street" as controlName'>
            <label [for]='controlName'>
              Ulica *
            </label>
            <select
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'>
              <option value=''>Wybierz</option>
              @for (item of form.getStreetList(form.city.value); track $index) {
                <option [value]='item.name'>{{ item.name }}</option>
              }
            </select>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      }
    </div>
    @if (form.parcels) {
      <fieldset>
        <legend>
          Działki
        </legend>
        <app-parcels-crud tag="parcels" formControlName="parcels">
        </app-parcels-crud>
      </fieldset>
    }
    <fieldset>
      <legend>
        Przewidywany termin wprowadzenia zmiany organizacji ruchu
      </legend>
      <div class="row">
        <div [ngClass]="form.projectType.value === 'Stałej' ? 'col-md-5' : 'col-md-4'">
          <div class='form-group' *ngIf='"startDate" as controlName'>
            <label [for]='controlName'>
              {{
                form.projectType.value === 'Stałej'
                  ?
                  'Przewidywany termin wprowadzenia zmiany organizacji ruchu'
                  : 'Przewidywany termin rozpoczęcia'
              }} *
            </label>
            <app-date-picker [id]='controlName' [formControlName]='controlName'>
            </app-date-picker>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        @if (form.endDate) {
          <div class="col-md-4">
            <div class='form-group' *ngIf='"endDate" as controlName'>
              <label [for]='controlName'>
                Przewidywany termin zakończenia *
              </label>
              <app-date-picker [id]='controlName' [formControlName]='controlName'>
              </app-date-picker>
              <app-validation-errors
                fieldLabel="Data: Przewidywany termin rozpoczęcia"
                secondFieldLabel="dacie: Przewidywany termin zakończenia"
                [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
        }
      </div>
    </fieldset>
    @if (!!form.projectType.value) {
      <fieldset>
        <legend>
          Kilometraż
        </legend>
        <div class="row">
          @if (form.providePointChainage) {
            <div class="col-12">
              <div class="form-group mb-0 mt-3">
                <div class="custom-radio custom-inline">
                  <input (change)="form.providePointChainageChange(true)" name="providePointChainage"
                         formControlName="providePointChainage" type="radio"
                         id="providePointChainageTrue" [value]="true">
                  <label for="providePointChainageTrue">
                    Chcę wprowadzić kilometraż pojedynczego punktu
                  </label>
                </div>
                <div class="custom-radio custom-inline">
                  <input (change)="form.providePointChainageChange(false)" name="providePointChainage"
                         formControlName="providePointChainage" type="radio"
                         id="providePointChainageFalse" [value]="false">
                  <label for="providePointChainageFalse">
                    Chcę wprowadzić kilometraż wybranego odcinka
                  </label>
                </div>
              </div>
            </div>
          }
          @if (form.chainageFrom) {
            <div class='col-md-3'>
              <div class='form-group' *ngIf='"chainageFrom" as controlName'>
                <label [for]='controlName'>
                  Kilometraż od *
                </label>
                <input
                  mask='separator.3'
                  decimalMarker=','
                  [dropSpecialCharacters]='false'
                  [id]='controlName'
                  [ngClass]='{ "is-invalid": form.showError(controlName) }'
                  [formControlName]='controlName'
                  placeholder='Wpisz tu kilometraż'
                  type='text'>
                <app-validation-errors [control]='form.get(controlName)'>
                </app-validation-errors>
              </div>
            </div>
          }
          @if (form.chainageTo) {
            <div class='col-md-3'>
              <div class='form-group' *ngIf='"chainageTo" as controlName'>
                <label [for]='controlName'>
                  Kilometraż do *
                </label>
                <input
                  mask='separator.3'
                  decimalMarker=','
                  [dropSpecialCharacters]='false'
                  [id]='controlName'
                  [ngClass]='{ "is-invalid": form.showError(controlName) }'
                  [formControlName]='controlName'
                  placeholder='Wpisz tu kilometraż'
                  type='text'>
                <app-validation-errors [control]='form.get(controlName)'>
                </app-validation-errors>
              </div>
            </div>
          }
          @if (form.chainage) {
            <div class='col-md-3'>
              <div class='form-group' *ngIf='"chainage" as controlName'>
                <label [for]='controlName'>
                  Kilometraż *
                </label>
                <input
                  mask='separator.3'
                  decimalMarker=','
                  [dropSpecialCharacters]='false'
                  [id]='controlName'
                  [ngClass]='{ "is-invalid": form.showError(controlName) }'
                  [formControlName]='controlName'
                  placeholder='Wpisz tu kilometraż'
                  type='text'>
                <app-validation-errors [control]='form.get(controlName)'>
                </app-validation-errors>
              </div>
            </div>
          }
        </div>
      </fieldset>
    }
    @if (form.organizerOrContractorType && form.organizerOrContractorName) {
      <fieldset>
        <legend>
          Organizator / Wykonawca
        </legend>
        <div class="row">
          <div class="col-md-6">
            <div class='form-group' *ngIf='"organizerOrContractorType" as controlName'>
              <label [for]='controlName'>
                Rodzaj
              </label>
              <select
                [id]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                [formControlName]='controlName'>
                <option value=''>Wybierz</option>
                <option value='Organizator imprezy lub innych czynności na drodze'>
                  Organizator imprezy lub innych czynności na drodze
                </option>
                <option value='Wykonawca robót drogowych'>
                  Wykonawca robót drogowych
                </option>
              </select>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
          <div class='col-md-6'>
            <div class='form-group' *ngIf='"organizerOrContractorName" as controlName'>
              <label [for]='controlName'>
                Dane Organizatora/Wykonawcy
              </label>
              <input
                [id]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                [formControlName]='controlName'
                placeholder='Wpisz tu dane Organizatora/Wykonawcy'
                type='text'>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
        </div>
      </fieldset>
    }
  </form>
  <div class='application-actions'>
    <button
      [disabled]="pending()"
      (click)="onCancel()"
      type='button'
      class='btn btn-secondary'>
        <span>
          Wstecz
        </span>
    </button>
    <button
      (click)="submitAndGoNext()"
      [disabled]="pending()"
      type='button'
      class='btn btn-primary'>
      <span>Zapisz i przejdź dalej</span>
    </button>
  </div>
} @else {
  <app-spinner>
    {{ pending() ? 'Poczekaj trwa zapisywania danych...' : 'Poczekaj trwa ładowanie danych...' }}
  </app-spinner>
}
